<svg [class]="classes">
  <circle
    [attr.cx]="circleSizes[size].cx"
    [attr.cy]="circleSizes[size].cy"
    [attr.r]="circleSizes[size].r"
    [class]="circleClasses"
  ></circle>
</svg>
